(function(){
    'use strict'

    angular
    .module('app.archivoCCSS')
    .controller('EditarGrandesContribuyentes', EditarGrandesContribuyentes);

    EditarGrandesContribuyentes.$inject = ['moment', '$q', '$scope', '$animationsSrv', '$routeParams','ArchivoCCSSService', 'logger', '$location', 'UserInfoService', 'EmpleadosService', 'CoreSrv', 'PuestosService', 'TurnosService'];

    function EditarGrandesContribuyentes(moment, $q, $scope, $animationsSrv, $routeParams, ArchivoCCSSService, logger, $location, UserInfoService, EmpleadosService, CoreSrv, PuestosService,TurnosService) {
    
        $animationsSrv.scrollToTop();

        var vm = this;
        var today = moment();

        vm.tiposCambio = [];
        vm.puestos = [];
        vm.turnos = [];
        vm.tiposSeguro = [];
        vm.tiposIncapacidad = [];
        vm.tiposPension = [];
        vm.tiposPermiso = [];

        vm.filterData = [];
        vm.empleados = [];

        vm.registroId = $routeParams.id ? $routeParams.id : 0;
        vm.p_anno = $routeParams.anno;
        vm.p_mes = $routeParams.mes;

        vm.registro = {
            companiaId: UserInfoService.getCompaniaId(),
            tipoCambio: -1,
            ocupacion: -1,
            montoSalario: 0,
            claseSeguro: -1,
            horasJornada: 0,
            claseJornada: -1,
            codigoCambio: '',
            fechaInicio: today.toDate(),
            fechaFin: today.toDate(),
            empleadoId: '',
            empleadoNombre: '',
            anno: vm.p_anno,
            mes: vm.p_mes,
            tipoIncapacidad: -1,
            tipoPension: -1,
            tipoPermiso: -1
        };

        vm.busquedaEmpleado = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId(),
            estado: -1
        };

        vm.meses = CoreSrv.getMeses();
        vm.annos = CoreSrv.getAnnos();

        vm.openModalEmpleados = function(){
            if(vm.empleados.length > 0){
                $('#myModalEmpleados').modal('toggle');   
            }
            else{
                var promise = EmpleadosService.getAll(vm.busquedaEmpleado);

                promise
                .then(function(result){
                    vm.empleados = result.data;
                    $('#myModalEmpleados').modal('toggle'); 
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los empleados.');
                            break;
                    }
                });
            }
             
        };

        vm.seleccionarEmpleado = function(e){
            vm.registro.empleadoId = e.id;
            vm.registro.empleadoNombre = e.nombre;
            vm.registro.claseSeguro = e.tipoSeguro;
            vm.registro.ocupacion = e.codigoOcupacionInternacional;
            vm.registro.claseJornada = e.codigoJornada == null ? -1 : e.codigoJornada;
            vm.registro.montoSalario = e.montoSalarioPromedio;
            $scope.grandesContribuyentesForm.empleadoId.$dirty = true;
            $scope.grandesContribuyentesForm.$dirty = true;
            $('#myModalEmpleados').modal('toggle');   
        };

        var promiseTiposCambio = getTiposCambio();
        var promiseTiposIncapacidad = getTiposIncapacidad();
        var promiseTiposPension = getTiposPension();
        var promisePuestos = getPuestos();
        var promiseTurnos = getTurnos();
        var promiseTiposSeguro = getTiposSeguro();
        var promiseTiposPermiso = getTiposPermiso();

        CargarRegistro();

        /**/
        function getTiposCambio(){
            var promise = ArchivoCCSSService.getTiposCambio()
            .then(function(tipos){
                vm.tiposCambio = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getTiposIncapacidad(){
            var promise = ArchivoCCSSService.getTiposIncapacidad()
            .then(function(tipos){
                vm.tiposIncapacidad = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de incapacidad.');
            }); 
            
            return promise;
        };

        function getTiposPension(){
            var promise = ArchivoCCSSService.getTiposPension()
            .then(function(tipos){
                vm.tiposPension = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de pensión.');
            }); 
            
            return promise;
        };

        function getTiposPermiso(){
            var promise = ArchivoCCSSService.getTiposPermiso()
            .then(function(tipos){
                vm.tiposPermiso = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de permiso.');
            }); 
            
            return promise;
        };

        function getPuestos(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getTurnos(){
            var promise = TurnosService.getAll()
            .then(function(turnos){
                vm.turnos = turnos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los turnos.');
            }); 
            
            return promise;
        };

        function getTiposSeguro(){
            var promise = ArchivoCCSSService.getTiposSeguro()
            .then(function(tiposSeguro){
                vm.tiposSeguro = tiposSeguro;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de seguro.');
            }); 
            
            return promise;
        };

        function CargarRegistro(){
            $q.all([promiseTiposCambio, promisePuestos, promiseTurnos, promiseTiposSeguro, promiseTiposIncapacidad, promiseTiposPension, promiseTiposPermiso]).then(getRegistro);
        }

        function getRegistro(){

            if(vm.registroId != 0){
                var promise = ArchivoCCSSService.getById(vm.registroId);

                promise
                .then(function(registro){
                    registro.fechaInicio = registro.fechaInicio == null ? null : moment(registro.fechaInicio).toDate();
                    registro.fechaFin = registro.fechaFin == null ? null : moment(registro.fechaFin).toDate();
                    registro.anno = registro.anno.toString();
                    registro.mes = registro.mes.toString();
                    registro.tipoIncapacidad = -1;
                    registro.tipoPermiso = -1;
                    registro.tipoPension = -1;
                    if(registro.tipoCambio == 'IN')
                    {
                        registro.tipoIncapacidad = registro.codigoCambio;
                    }
                    else if(registro.tipoCambio == 'PE')
                    {
                        registro.tipoPermiso = registro.codigoCambio;
                    }
                    else if(registro.tipoCambio == 'PN')
                    {
                        registro.tipoPension = registro.codigoCambio;
                    }

                    vm.registro = registro;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function doFormValidations(){
            validateTipoCambio();
            validateTipoIncapacidad();
            validateTipoPension();
            validateTipoPermiso();
            validateFechaInicio();
            validateFechaFin();
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.grandesContribuyentesForm.$valid){
                if(!vm.registro.id){
                    saveRegistro();
                }
                else if($scope.grandesContribuyentesForm.$dirty){
                    updateRegistro();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveRegistro() {
            if(vm.registro.tipoAusencia == -1){
                vm.registro.tipoAusencia = null;
            }
            var promise = ArchivoCCSSService.save(vm.registro);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearRegistroData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateRegistro(){
            if(vm.registro.tipoAusencia == -1){
                vm.registro.tipoAusencia = null;
            }
            var promise = ArchivoCCSSService.update(vm.registro);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/archivo-grandes-contribuyentes');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearRegistroData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.registro = {
                companiaId: UserInfoService.getCompaniaId(),
                tipoCambio: -1,
                ocupacion: -1,
                montoSalario: 0,
                claseSeguro: -1,
                horasJornada: 0,
                claseJornada: -1,
                codigoCambio: '',
                fechaInicio: today.toDate(),
                fechaFin: today.toDate(),
                empleadoId: '',
                empleadoNombre: '',
                anno: vm.p_anno,
                mes: vm.p_mes,
                tipoIncapacidad: -1,
                tipoPension: -1,
                tipoPermiso: -1
            };
            // Set back to pristine.
            $scope.grandesContribuyentesForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.grandesContribuyentesForm.$setUntouched();
        };

        function setCodigoCambio(){
            if(vm.registro.tipoCambio === 'IC' )
            {
                vm.registro.codigoCambio = 'IC';
            }
            else if(vm.registro.tipoCambio === 'PN'){
                if(vm.registro.tipoPension != -1)
                {
                    vm.registro.codigoCambio = vm.registro.tipoPension;
                }
            }
            else if(vm.registro.tipoCambio === 'IN'){
                if(vm.registro.tipoIncapacidad != -1)
                {
                    vm.registro.codigoCambio = vm.registro.tipoIncapacidad;
                }
            }
            else if(vm.registro.tipoCambio === 'PE'){
                if(vm.registro.tipoPermiso != -1)
                {
                    vm.registro.codigoCambio = vm.registro.tipoPermiso;
                }
            }
            else{
                vm.registro.codigoCambio = '';
            }
        };

        vm.tipoCambiosChange = function(){
            if(validateTipoCambio()){
                setCodigoCambio();
            }
        };

        function validateTipoCambio(){
            if(vm.registro.tipoCambio == -1){
                $scope.grandesContribuyentesForm.tipoCambio.$setValidity("different", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.tipoCambio.$setValidity("different", true);
                return true;
            }
        };

        function validateTipoPension(){
            if(vm.registro.tipoCambio == 'PN' && vm.registro.tipoPension == -1){
                $scope.grandesContribuyentesForm.tipoPension.$setValidity("different", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.tipoPension.$setValidity("different", true);
                return true;
            }
        };

        vm.tiposPensionChange = function(){
            if(validateTipoPension()){
                setCodigoCambio();
            }
        };

        function validateTipoIncapacidad(){
            if(vm.registro.tipoCambio == 'IN' && vm.registro.tipoIncapacidad == -1){
                $scope.grandesContribuyentesForm.tipoIncapacidad.$setValidity("different", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.tipoIncapacidad.$setValidity("different", true);
                return true;
            }
        };

        vm.tiposIncapacidadChange = function(){
            if(validateTipoIncapacidad()){
                setCodigoCambio();
            }
        };

        function validateTipoPermiso(){
            if(vm.registro.tipoCambio == 'PE' && vm.registro.tipoPermiso == -1){
                $scope.grandesContribuyentesForm.tipoPermiso.$setValidity("different", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.tipoPermiso.$setValidity("different", true);
                return true;
            }
        };

        vm.tiposPermisoChange = function(){
            if(validateTipoPermiso()){
                setCodigoCambio();
            }
        };

        function validateFechaFin(){

            var fechaFinRequerida = vm.registro.tipoCambio == 'IN' || vm.registro.tipoCambio == 'PE';
            if(!vm.registro.fechaFin && fechaFinRequerida){
                $scope.grandesContribuyentesForm.fechaFin.$setValidity("required", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.fechaFin.$setValidity("required", true);
            }

            if(fechaFinRequerida){
                if((moment(vm.registro.fechaFin).month()+1) != vm.registro.mes || 
                moment(vm.registro.fechaFin).year() != vm.registro.anno){
                    $scope.grandesContribuyentesForm.fechaFin.$setValidity("range", false);
                    return false;
                }
                else{
                    $scope.grandesContribuyentesForm.fechaFin.$setValidity("range", true);
                }
            }

            return true;
        };

        function validateFechaInicio(){
            if(!vm.registro.fechaInicio){
                $scope.grandesContribuyentesForm.fechaInicio.$setValidity("required", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.fechaInicio.$setValidity("required", true);
            }

            if((moment(vm.registro.fechaInicio).month()+1) != vm.registro.mes || 
                moment(vm.registro.fechaInicio).year() != vm.registro.anno){
                $scope.grandesContribuyentesForm.fechaInicio.$setValidity("range", false);
                return false;
            }
            else{
                $scope.grandesContribuyentesForm.fechaInicio.$setValidity("range", true);
            }

            return true;

        };

        vm.fechaInicioChange = function(){
            validateFechaInicio();
        };

        vm.fechaFinChange = function(){
            validateFechaFin();
        };

        vm.filterEmpleados = function(){
            vm.filterData = vm.empleados.filter(function(g) {
                return (g.id.toString().indexOf(vm.busquedaEmpleado.id) >= 0 || !vm.busquedaEmpleado.id) && 
                (g.nombre.toLowerCase().indexOf(vm.busquedaEmpleado.nombre.toLowerCase()) >= 0 || !vm.busquedaEmpleado.nombre);
            }).slice(0, 100);
        };

        vm.fechaInicioOptions = {
            showWeeks: true
        };

        vm.openFechaInicio = function(){
            vm.fechaInicioOpened = !vm.fechaInicioOpened;
        };

        vm.fechaFinOptions = {
            showWeeks: true
        };

        vm.openFechaFin = function(){
            vm.fechaFinOpened = !vm.fechaFinOpened;
        };

    }
})();